import { ComponentChildren, h } from 'preact';

export interface SegmentedControlRegionProps {
    id: string;
    ariaLabelledBy: string;
    className?: string;
    children: ComponentChildren;
}

export const SegmentedControlRegion = ({ id, ariaLabelledBy, className, children }: Readonly<SegmentedControlRegionProps>) => {
    return (
        <div id={id} aria-labelledby={ariaLabelledBy} className={className} role="tabpanel">
            {children}
        </div>
    );
};
